export default __webpack_public_path__ + "static/media/clean.72fd864b.png";